(() => {
  'use strict';
  function initialize(root) {
    if (root.dataset.oaInitialized === 'true') return;
    root.dataset.oaInitialized = 'true';
    const buttons = Array.from(root.querySelectorAll('[data-oa-pillar]'));
    const toggleAll = root.querySelector('[data-oa-toggle-all]');
    if (!toggleAll || !buttons.length) return;
    const setExpanded = (button, expanded) => {
      const body = document.getElementById(button.getAttribute('aria-controls'));
      if (!body || !root.contains(body)) return;
      button.setAttribute('aria-expanded', String(expanded));
      body.hidden = !expanded;
      button.querySelector('.oa-pillar-sign').textContent = expanded ? '–' : '+';
    };
    const syncToggleAll = () => {
      const allOpen = buttons.every(button => button.getAttribute('aria-expanded') === 'true');
      toggleAll.textContent = allOpen ? 'Collapse all' : 'Expand all';
      toggleAll.setAttribute('aria-expanded', String(allOpen));
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
      syncToggleAll();
    }));
    toggleAll.addEventListener('click', () => {
      const expanded = !buttons.every(button => button.getAttribute('aria-expanded') === 'true');
      buttons.forEach(button => setExpanded(button, expanded));
      syncToggleAll();
    });
  }
  const scan = scope => scope.querySelectorAll('[data-our-approach]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
